import {
    REQUEST_LOST_ITEM,
    REQUEST_LOST_ITEM_SUCCESS,
    REQUEST_LOST_ITEM_FAILURE
} from "../../constant/other/LostItemConstant";

const initialState = {
    lostItem: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const lostItemReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_LOST_ITEM:
            return {
                ...state,
                lostItem: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_LOST_ITEM_SUCCESS:
            return {
                ...state,
                lostItem: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_LOST_ITEM_FAILURE:
            return {
                ...state,
                lostItem: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
